import { render, staticRenderFns } from "./serviceAdmin.vue?vue&type=template&id=4bed51de&scoped=true&"
import script from "./serviceAdmin.vue?vue&type=script&lang=js&"
export * from "./serviceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./serviceAdmin.vue?vue&type=style&index=0&id=4bed51de&scoped=true&lang=css&"
import style1 from "./serviceAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed51de",
  null
  
)

export default component.exports